import axios, { AxiosInstance, AxiosResponse } from 'axios'
import * as qs from 'qs'
import { isTokenValid } from './auth'

interface IRequestHeaders {
  [key: string]: string
}

interface IRequestParams {
  [key: string]: any
}

interface IRequestData {
  [key: string]: any
}

interface IRequestOptions {
  headers?: IRequestHeaders
  params?: IRequestParams
  data?: IRequestData
}

interface IRequestInterface {
  get(url: string, options?: IRequestOptions): Promise<any>

  delete(url: string, options?: IRequestOptions): Promise<any>

  post(url: string, data: IRequestData, options?: IRequestOptions): Promise<any>

  put(url: string, data: IRequestData, options?: IRequestOptions): Promise<any>

  patch(url: string, data: IRequestData, options?: IRequestOptions): Promise<any>
}

class Request implements IRequestInterface {
  private baseURL: string
  private defaultHeaders: object
  private axios: AxiosInstance

  constructor(baseURL: string, additionalHeaders: object = {}) {
    this.baseURL = baseURL
    this.defaultHeaders = Object.assign({}, this.getAuthHeaders(), additionalHeaders)
    this.init()
  }

  public async get<T>(url: string, options?: IRequestOptions): Promise<AxiosResponse<T>> {
    this.updateAuthToken()
    return await this.axios.get(url, options)
  }

  public async delete<T>(url: string, options?: IRequestOptions): Promise<AxiosResponse<T>> {
    this.updateAuthToken()
    return await this.axios.delete(url, options)
  }

  public async post<T>(url: string, data?: IRequestData, options?: IRequestOptions): Promise<AxiosResponse<T>> {
    this.updateAuthToken()
    return await this.axios.post(url, data, options)
  }

  public async put<T>(url: string, data?: IRequestData, options?: IRequestOptions): Promise<AxiosResponse<T>> {
    this.updateAuthToken()
    return await this.axios.put(url, data, options)
  }

  public async patch<T>(url: string, data?: IRequestData, options?: IRequestOptions): Promise<AxiosResponse<T>> {
    this.updateAuthToken()
    return await this.axios.patch(url, data, options)
  }

  public removeAuthToken() {
    const { Authorization, ...withoutToken } = this.axios.defaults.headers
    this.axios.defaults.headers = withoutToken
  }

  private init() {
    const axiosInstance = axios.create({
      baseURL: this.baseURL,
      headers: this.defaultHeaders,
      paramsSerializer: query => {
        const queryString = qs.stringify(query)
        return queryString
      }
    })
    axiosInstance.interceptors.response.use(
      response => response,
      error => {
        if (error.response) {
          return Promise.reject(error.response)
        } else if (error.request) {
          return Promise.reject(error.request)
        } else {
          return Promise.reject(error.message)
        }
      }
    )
    this.axios = axiosInstance
  }

  private updateAuthToken() {
    if (isTokenValid()) {
      const token = localStorage.getItem('accessToken')
      const tokenHeader = { Authorization: `Bearer ${token}` }
      return (this.axios.defaults.headers = Object.assign({}, this.axios.defaults.headers, tokenHeader))
    }
    this.removeAuthToken()
  }

  private getAuthHeaders() {
    return {
      Accept: 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  }
}

let url =
  process.env.REACT_APP_ENV === 'production' ? (window as any).location.origin : process.env.REACT_APP_GATEWAY_URL
url = url || 'http://localhost:8080'
// console.log('gateway url: ', url)
// console.log('env vars: ', process.env)
export const serverApi = new Request(url)



// WEBPACK FOOTER //
// ./src/utils/request.ts